<template>
  <div class="subheader subheader-sticky justify-content-start shadow-sm">
    <img v-if="icon" class="me-2" :src="'/img/icon/page-' + icon + '.png'" :alt="icon">
    <h1 class="subheader-text h4 fw-bold mb-0">{{ title }}</h1>
  </div>
</template>

<script>
export default {
  name: 'SubHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: ''
    }
  },
}
</script>
